<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import ControlIcon from "@/components/ControlIcon.vue";

const props = defineProps({
  name: {
    type: String,
    default: null,
  },
  id: {
    type: String,
    default: null,
  },
  autocomplete: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  options: {
    type: Array,
    default: null,
  },
  type: {
    type: String,
    default: "text",
  },
  modelValue: {
    type: [String, Number, Boolean, Array, Object],
    default: "",
  },
  required: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  ctrlKFocus: Boolean,
});

const emit = defineEmits(["update:modelValue", "right-icon-click"]);

const computedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});

const inputElClass = computed(() => {
  const base = [
    "px-3  max-w-full focus:ring-1 focus:ring-pink-250 focus:border-0 focus:outline-none border-gray-150 rounded-lg w-full",
    "dark:placeholder-gray-250",
    computedType.value === "textarea" ? "h-24" : "h-10",
    props.borderless ? "border-0" : "border",
    props.transparent ? "bg-transparent" : "bg-white dark:bg-gray-800",
  ];

  if (props.icon) {
    base.push("pl-10");
  }

  return base;
});

const computedType = computed(() => (props.options ? "select" : props.type));

const controlIconH = computed(() =>
  props.type === "textarea" ? "h-full" : "h-12"
);

const store = useStore();

const inputEl = ref(null);

if (props.ctrlKFocus) {
  const fieldFocusHook = (e) => {
    if (e.ctrlKey && e.key === "k") {
      e.preventDefault();
      inputEl.value.focus();
    } else if (e.key === "Escape") {
      inputEl.value.blur();
    }
  };

  onMounted(() => {
    if (!store.state.isFieldFocusRegistered) {
      window.addEventListener("keydown", fieldFocusHook);

      store.commit("basic", {
        key: "isFieldFocusRegistered",
        value: true,
      });
    } else {
      // console.error('Duplicate field focus event')
    }
  });

  onBeforeUnmount(() => {
    window.removeEventListener("keydown", fieldFocusHook);

    store.commit("basic", {
      key: "isFieldFocusRegistered",
      value: false,
    });
  });
}
</script>

<template>
  <div class="relative text-gray-600 focus-within:text-gray-400 mb-4">
    <span class="absolute flex items-center pl-2 py-2">
      <button type="submit" class="p-1 focus:outline-none focus:shadow-outline">
        <svg
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          class="w-4 h-4"
        >
          <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
      </button>
    </span>
    <input v-model="computedValue"
    :id="id"
      ref="inputEl"
     
      :name="name"
      :autocomplete="autocomplete"
      :required="required"
     
     
      :class="inputElClass"
      type="search"
      class="h-10 py-2.5 shadow-sm w-full text-sm text-white border-0 border-gray-150 bg-white rounded-full pl-10 focus:outline-none focus:border-pink-40 focus:ring-1 focus:ring-pink-250 focus:bg-white focus:text-gray-900"
      placeholder="Search..."
     
    />
  </div>
</template>

